import React from 'react';

function Accordion({ items, openIndex, onToggle }) {
  return (
    <div className="flex flex-col gap-3">
      {items.map((item, index) => {
        const isOpen = openIndex === index;
        return (
          <div key={item.title} className="glass-card overflow-hidden">
            <button
              type="button"
              onClick={() => onToggle(isOpen ? null : index)}
              className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-white/[0.02]"
              aria-expanded={isOpen}
            >
              <div className="flex items-center gap-3">
                {item.icon && <span className="text-xl">{item.icon}</span>}
                <span className="font-bold text-white">{item.title}</span>
              </div>
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-white/10 text-lg text-primary">
                {isOpen ? '−' : '+'}
              </span>
            </button>
            {isOpen && (
              <div className="border-t border-white/5 px-5 pb-5 pt-1">
                {item.content ? (
                  item.content
                ) : (
                  <ul className="list-inside list-disc space-y-2 text-silver leading-relaxed">
                    {(item.items || []).map((line) => (
                      <li key={line}>{line}</li>
                    ))}
                  </ul>
                )}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

export default Accordion;
